import React, {VoidFunctionComponent, SVGAttributes} from 'react';

const DHMLogo: VoidFunctionComponent<SVGAttributes<SVGSVGElement>> = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 1093.00049 284"
    aria-labelledby="deutsches-historisches-museum"
    role="img"
    {...props}>
    <title id="deutsches-historisches-museum">
      Deutsches Historisches Museum
    </title>
    <defs>
      <linearGradient
        id="dhm-logo-linear-gradient"
        x1="0.9815"
        y1="569.71225"
        x2="2.09045"
        y2="569.71225"
        gradientTransform="matrix(425.48, 0, 0, -425.48, -460.08, 242542.9)"
        gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#fff"></stop>
        <stop offset="0.09335" stopColor="#f9f9f9"></stop>
        <stop offset="0.21838" stopColor="#e8e8e8"></stop>
        <stop offset="0.36139" stopColor="#ccc"></stop>
        <stop offset="0.51777" stopColor="#a5a5a5"></stop>
        <stop offset="0.68508" stopColor="#737373"></stop>
        <stop offset="0.85868" stopColor="#373737"></stop>
        <stop offset="1"></stop>
      </linearGradient>
      <linearGradient
        id="dhm-logo-linear-gradient-2"
        x1="1.05072"
        y1="569.49114"
        x2="2.15894"
        y2="569.49114"
        gradientTransform="matrix(259.30308, 0.16624, 0.16624, -259.30308, -458.94158, 147812.22469)"
        gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#fff"></stop>
        <stop offset="0.10345" stopColor="#fafafa"></stop>
        <stop offset="0.22707" stopColor="#ebebeb"></stop>
        <stop offset="0.36111" stopColor="#d3d3d3"></stop>
        <stop offset="0.5025" stopColor="#b2b2b2"></stop>
        <stop offset="0.6497" stopColor="#868686"></stop>
        <stop offset="0.80175" stopColor="#515151"></stop>
        <stop offset="0.95503" stopColor="#141414"></stop>
        <stop offset="1"></stop>
      </linearGradient>
      <linearGradient
        id="dhm-logo-linear-gradient-3"
        x1="1.62037"
        y1="569.44267"
        x2="2.72033"
        y2="569.44267"
        gradientTransform="matrix(188.82601, -0.00016, -0.00016, -188.82601, -239.92875, 107712.13286)"
        gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#fff"></stop>
        <stop offset="0.08509" stopColor="#f6f6f6"></stop>
        <stop offset="0.22104" stopColor="#dfdfdf"></stop>
        <stop offset="0.39086" stopColor="#b9b9b9"></stop>
        <stop offset="0.58789" stopColor="#848484"></stop>
        <stop offset="0.80488" stopColor="#424242"></stop>
        <stop offset="1"></stop>
      </linearGradient>
      <linearGradient
        id="dhm-logo-linear-gradient-4"
        x1="0.93581"
        y1="569.96767"
        x2="2.04401"
        y2="569.96767"
        gradientTransform="matrix(307.92519, 0, 0, -307.9252, -456.94781, 175649.142)"
        gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#fff"></stop>
        <stop offset="0.09172" stopColor="#f9f9f9"></stop>
        <stop offset="0.21739" stopColor="#e7e7e7"></stop>
        <stop offset="0.36272" stopColor="#cacaca"></stop>
        <stop offset="0.52281" stopColor="#a2a2a2"></stop>
        <stop offset="0.69502" stopColor="#6e6e6e"></stop>
        <stop offset="0.87448" stopColor="#303030"></stop>
        <stop offset="1"></stop>
      </linearGradient>
      <linearGradient
        id="dhm-logo-linear-gradient-5"
        x1="0.99773"
        y1="568.81582"
        x2="2.10636"
        y2="568.81582"
        gradientTransform="matrix(-0.00208, -516.87947, -516.87945, 0.00207, 294137.34612, 998.59576)"
        gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#fff"></stop>
        <stop offset="0.09525" stopColor="#f0f0f0"></stop>
        <stop offset="0.27957" stopColor="#c7c7c7"></stop>
        <stop offset="0.53457" stopColor="#868686"></stop>
        <stop offset="0.84704" stopColor="#2e2e2e"></stop>
        <stop offset="1"></stop>
      </linearGradient>
      <linearGradient
        id="dhm-logo-linear-gradient-7"
        x1="0.94327"
        y1="569.96767"
        x2="2.04289"
        y2="569.96767"
        xlinkHref="#dhm-logo-linear-gradient-4"></linearGradient>
      <mask
        id="dhm-logo-mask"
        x="-1"
        y="-1"
        width="258.26508"
        height="285.46484"
        maskUnits="userSpaceOnUse">
        <g transform="translate(0.00049)">
          <rect
            fill="url(#dhm-logo-linear-gradient)"
            x="-1.00049"
            y="-1"
            width="258.26508"
            height="285.46484"></rect>
        </g>
      </mask>
      <mask
        id="dhm-logo-mask-2"
        x="-54.46191"
        y="-49.53369"
        width="365.18899"
        height="382.53269"
        maskUnits="userSpaceOnUse">
        <g transform="translate(0.00049)">
          <rect
            fill="url(#dhm-logo-linear-gradient-2)"
            x="-25.86287"
            y="-23.08135"
            width="307.98944"
            height="329.6275"
            transform="translate(-24.76318 27.15075) rotate(-11.03674)"></rect>
        </g>
      </mask>
      <mask
        id="dhm-logo-mask-3"
        x="-136.86621"
        y="-126.541"
        width="612.92139"
        height="626.1709"
        maskUnits="userSpaceOnUse">
        <g transform="translate(0.00049)">
          <rect
            fill="url(#dhm-logo-linear-gradient-3)"
            x="-74.82034"
            y="-46.0263"
            width="488.82868"
            height="465.14151"
            transform="translate(-66.43743 275.14535) rotate(-68.29995)"></rect>
        </g>
      </mask>
      <mask
        id="dhm-logo-mask-5"
        x="-80.81541"
        y="-73.21039"
        width="417.89499"
        height="429.88619"
        maskUnits="userSpaceOnUse">
        <g transform="translate(0.00049)">
          <rect
            fill="url(#dhm-logo-linear-gradient-5)"
            x="-46.1188"
            y="-23.48851"
            width="348.5013"
            height="330.44192"
            transform="translate(-44.87002 222.8263) rotate(-72.99977)"></rect>
        </g>
      </mask>
      <mask
        id="dhm-logo-mask-7"
        x="0"
        y="0"
        width="256.26508"
        height="283.46484"
        maskUnits="userSpaceOnUse">
        <g transform="translate(0.00049)">
          <rect
            fill="url(#dhm-logo-linear-gradient-7)"
            x="-0.00049"
            width="256.26508"
            height="283.46484"></rect>
        </g>
      </mask>
    </defs>
    <g id="Boundingbox">
      <rect fill="none" width="1093.00049" height="284"></rect>
    </g>
    <g id="DHM">
      <g id="DHM-l_GR">
        <g id="MUSEUM">
          <path
            fill="var(--dhm-ci-logo-color)"
            d="M387.16889,229.8354l-16.4785,19.7745h-2.332L351.96,229.8354v33.4395H338.45609V208.6143h11.6562l19.4522,22.8286,19.4521-22.8286h11.6563v54.6606h-13.504Z"
            transform="translate(0.00049)"></path>
          <path
            fill="var(--dhm-ci-logo-color)"
            d="M439.665,238.9189c0,7.8775,4.01959,12.7002,11.81639,12.7002,8.0381,0,12.0567-4.9834,12.0567-12.7002V208.6143H477.043v31.1889c0,13.1021-9.003,24.356-25.56161,24.356-16.3183,0-25.3212-10.2085-25.3212-24.356V208.6143H439.665Z"
            transform="translate(0.00049)"></path>
          <path
            fill="var(--dhm-ci-logo-color)"
            d="M502.93259,247.0376a32.64074,32.64074,0,0,0,17.2822,5.4658c5.3858,0,8.7618-1.7685,8.7618-5.2246,0-2.4116-1.76859-3.8584-6.1895-4.9839l-8.9228-2.4116c-9.40429-2.4917-13.90629-7.4756-13.90629-15.1924,0-9.3242,7.15429-16.8003,21.86519-16.8003a47.02685,47.02685,0,0,1,19.6934,4.3408l-3.7773,11.6558a36.6361,36.6361,0,0,0-16.4795-4.4214c-5.3057,0-7.5557,1.688-7.5557,4.3408,0,2.4117,1.6074,3.376,4.9834,4.3409l9.7266,2.8134c10.0478,2.8936,14.3886,7.7969,14.3886,15.3531,0,10.5302-9.2441,17.7646-22.9091,17.7646-8.0391,0-16.47859-2.7329-20.0957-4.7427Z"
            transform="translate(0.00049)"></path>
          <path
            fill="var(--dhm-ci-logo-color)"
            d="M566.44039,263.2749V208.6143h43.88869v11.7358H579.38179v9.4048h25.08009v11.3345H579.38179v10.4497h30.94729v11.7358Z"
            transform="translate(0.00049)"></path>
          <path
            fill="var(--dhm-ci-logo-color)"
            d="M647.47268,238.9189c0,7.8775,4.0185,12.7002,11.8164,12.7002,8.038,0,12.0576-4.9834,12.0576-12.7002V208.6143h13.5039v31.1889c0,13.1021-9.0029,24.356-25.5615,24.356-16.3184,0-25.3213-10.2085-25.3213-24.356V208.6143h13.5049Z"
            transform="translate(0.00049)"></path>
          <path
            fill="var(--dhm-ci-logo-color)"
            d="M759.292,229.8354l-16.47852,19.7745h-2.3311L724.084,229.8354v33.4395H710.58008V208.6143h11.6553l19.4531,22.8286,19.4521-22.8286h11.6553v54.6606H759.292Z"
            transform="translate(0.00049)"></path>
        </g>
        <g id="HISTORISCHES">
          <path
            fill="var(--dhm-ci-logo-color)"
            d="M377.76369,153.5176H351.96v21.7837H338.45609V120.6406H351.96v21.1406h25.80369V120.6406h13.5049v54.6607h-13.5049Z"
            transform="translate(0.00049)"></path>
          <path
            fill="var(--dhm-ci-logo-color)"
            d="M417.63959,120.6406h13.504v54.6607h-13.504Z"
            transform="translate(0.00049)"></path>
          <path
            fill="var(--dhm-ci-logo-color)"
            d="M458.39749,159.064a32.64045,32.64045,0,0,0,17.2822,5.4658c5.3857,0,8.7617-1.7686,8.7617-5.2246,0-2.4116-1.7685-3.8584-6.18939-4.9839l-8.92291-2.4116c-9.4043-2.4917-13.9062-7.4756-13.9062-15.1924,0-9.3242,7.1542-16.8003,21.8652-16.8003a47.02592,47.02592,0,0,1,19.6933,4.3408l-3.7773,11.6558a36.63539,36.63539,0,0,0-16.4795-4.4214c-5.3057,0-7.5557,1.688-7.5557,4.3408,0,2.4116,1.6075,3.376,4.9834,4.3408l9.7266,2.8135c10.0479,2.8936,14.3887,7.7969,14.3887,15.353,0,10.5303-9.2442,17.7647-22.9092,17.7647-8.0391,0-16.4785-2.7329-20.0957-4.7427Z"
            transform="translate(0.00049)"></path>
          <path
            fill="var(--dhm-ci-logo-color)"
            d="M546.42289,132.457v42.8443H532.918V132.457H516.11819V120.6406h46.622V132.457Z"
            transform="translate(0.00049)"></path>
          <path
            fill="var(--dhm-ci-logo-color)"
            d="M607.03608,119.8369c16.1563,0,28.21392,12.0571,28.21392,28.2144,0,15.9961-12.05762,28.0537-28.21392,28.0537-15.99608,0-28.05469-12.0576-28.05469-28.0537C578.98139,131.894,591.04,119.8369,607.03608,119.8369Zm0,43.5679c8.8418,0,14.8711-6.6719,14.8711-15.3535,0-8.8423-6.0293-15.4336-14.8711-15.4336-8.6015,0-14.87108,6.5913-14.87108,15.4336C592.165,156.7329,598.43458,163.4048,607.03608,163.4048Z"
            transform="translate(0.00049)"></path>
          <path
            fill="var(--dhm-ci-logo-color)"
            d="M658.32618,120.6406H684.29c12.70018,0,21.05958,5.7876,21.05958,18.0865,0,8.1186-5.3857,14.2275-12.9414,16.3979l15.916,17.604v2.5723h-14.3887l-16.6396-19.3726h-5.4658v19.3726h-13.5039Zm13.5039,11.7359v13.5044h12.2187c4.4209,0,7.3145-2.733,7.3145-6.752,0-4.1802-2.8936-6.7524-7.3145-6.7524Z"
            transform="translate(0.00049)"></path>
          <path
            fill="var(--dhm-ci-logo-color)"
            d="M730.43548,120.6406h13.504v54.6607h-13.504Z"
            transform="translate(0.00049)"></path>
          <path
            fill="var(--dhm-ci-logo-color)"
            d="M771.19238,159.064a32.64074,32.64074,0,0,0,17.2822,5.4658c5.3858,0,8.7617-1.7686,8.7617-5.2246,0-2.4116-1.7685-3.8584-6.1894-4.9839l-8.92288-2.4116c-9.40522-2.4917-13.90622-7.4756-13.90622-15.1924,0-9.3242,7.1543-16.8003,21.86422-16.8003a47.03568,47.03568,0,0,1,19.69438,4.3408L805.998,135.9136a36.63131,36.63131,0,0,0-16.47852-4.4214c-5.3056,0-7.5566,1.688-7.5566,4.3408,0,2.4116,1.6084,3.376,4.9844,4.3408l9.7265,2.8135c10.0479,2.8936,14.3877,7.7969,14.3877,15.353,0,10.5303-9.2431,17.7647-22.9092,17.7647-8.038,0-16.4785-2.7329-20.0957-4.7427Z"
            transform="translate(0.00049)"></path>
          <path
            fill="var(--dhm-ci-logo-color)"
            d="M860.42288,163.6455a23.70879,23.70879,0,0,0,15.0312-5.3852l6.1895,9.726a31.49089,31.49089,0,0,1-21.6231,8.1187c-16.47848,0-28.8574-12.1377-28.8574-28.1338,0-15.9966,12.37892-28.1343,28.8574-28.1343a31.48855,31.48855,0,0,1,21.6231,8.1187l-6.1895,9.7265a23.70609,23.70609,0,0,0-15.0312-5.3857c-9.2442,0-15.3536,6.9932-15.3536,15.6748C845.06928,156.6523,851.17868,163.6455,860.42288,163.6455Z"
            transform="translate(0.00049)"></path>
          <path
            fill="var(--dhm-ci-logo-color)"
            d="M943.70508,153.5176h-25.8028v21.7837h-13.5039V120.6406h13.5039v21.1406h25.8028V120.6406H957.21v54.6607H943.70508Z"
            transform="translate(0.00049)"></path>
          <path
            fill="var(--dhm-ci-logo-color)"
            d="M983.502,175.3013V120.6406h43.8886v11.7359H996.44337v9.4047h25.07913v11.3345H996.44337v10.4497h30.94723v11.7359Z"
            transform="translate(0.00049)"></path>
          <path
            fill="var(--dhm-ci-logo-color)"
            d="M1052.1533,159.064a32.64732,32.64732,0,0,0,17.2832,5.4658c5.3858,0,8.7617-1.7686,8.7617-5.2246,0-2.4116-1.7685-3.8584-6.1894-4.9839l-8.9229-2.4116c-9.4052-2.4917-13.9062-7.4756-13.9062-15.1924,0-9.3242,7.1543-16.8003,21.8642-16.8003a47.02685,47.02685,0,0,1,19.6934,4.3408l-3.7773,11.6558a36.63194,36.63194,0,0,0-16.4786-4.4214c-5.3056,0-7.5566,1.688-7.5566,4.3408,0,2.4116,1.6084,3.376,4.9844,4.3408l9.7265,2.8135c10.0479,2.8936,14.3887,7.7969,14.3887,15.353,0,10.5303-9.2441,17.7647-22.9101,17.7647-8.0381,0-16.4786-2.7329-20.0957-4.7427Z"
            transform="translate(0.00049)"></path>
        </g>
        <g id="DEUTSCHES">
          <path
            fill="var(--dhm-ci-logo-color)"
            d="M338.45609,32.667h24.5976c16.15631.08061,28.2149,9.646,28.2149,27.41061,0,17.604-12.05859,27.25-28.2149,27.25h-24.5976ZM351.96,44.40281v31.189h10.45019c8.8427,0,14.8711-5.5464,14.8711-15.5142,0-10.1284-6.0284-15.6748-14.8711-15.6748Z"
            transform="translate(0.00049)"></path>
          <path
            fill="var(--dhm-ci-logo-color)"
            d="M413.86129,87.3276V32.667H457.751V44.40281H426.80369v9.4048h25.0791v11.3345h-25.0791v10.4497H457.751V87.3276Z"
            transform="translate(0.00049)"></path>
          <path
            fill="var(--dhm-ci-logo-color)"
            d="M494.89359,62.97171c0,7.8774,4.0195,12.7002,11.81641,12.7002,8.038,0,12.05659-4.9834,12.05659-12.7002V32.667h13.5049V63.856c0,13.102-9.0029,24.3559-25.56149,24.3559-16.31841,0-25.32131-10.20849-25.32131-24.3559V32.667h13.5049Z"
            transform="translate(0.00049)"></path>
          <path
            fill="var(--dhm-ci-logo-color)"
            d="M583.32129,44.48341V87.3276h-13.5049V44.48341h-16.7998V32.667h46.62209V44.48341Z"
            transform="translate(0.00049)"></path>
          <path
            fill="var(--dhm-ci-logo-color)"
            d="M622.39158,71.09031a32.64735,32.64735,0,0,0,17.2832,5.4659c5.3857,0,8.7617-1.7686,8.7617-5.2247,0-2.4116-1.76848-3.8584-6.1894-4.9838l-8.9229-2.41171c-9.4053-2.49169-13.90618-7.47559-13.90618-15.19229,0-9.3243,7.15428-16.8003,21.86418-16.8003a47.02685,47.02685,0,0,1,19.6934,4.3408l-3.7774,11.6557a36.6311,36.6311,0,0,0-16.4785-4.4213c-5.3056,0-7.5566,1.6879-7.5566,4.3408,0,2.41159,1.6084,3.376,4.9844,4.3408l9.72652,2.8135c10.04788,2.8935,14.38868,7.7968,14.38868,15.353,0,10.53029-9.2441,17.76459-22.9102,17.76459-8.038,0-16.47848-2.73289-20.0957-4.74259Z"
            transform="translate(0.00049)"></path>
          <path
            fill="var(--dhm-ci-logo-color)"
            d="M711.62208,75.67191a23.70956,23.70956,0,0,0,15.0322-5.3853l6.1895,9.7261a31.49081,31.49081,0,0,1-21.6231,8.11859c-16.4785,0-28.8574-12.13759-28.8574-28.13369,0-15.99661,12.3789-28.1343,28.8574-28.1343a31.489,31.489,0,0,1,21.6231,8.1186l-6.1895,9.7266a23.70683,23.70683,0,0,0-15.0322-5.3857c-9.2432,0-15.3526,6.9931-15.3526,15.6748C696.26948,68.67871,702.37888,75.67191,711.62208,75.67191Z"
            transform="translate(0.00049)"></path>
          <path
            fill="var(--dhm-ci-logo-color)"
            d="M794.90428,65.54391h-25.8027V87.3276h-13.5039V32.667h13.5039V53.80761h25.8027V32.667h13.5049V87.3276h-13.5049Z"
            transform="translate(0.00049)"></path>
          <path
            fill="var(--dhm-ci-logo-color)"
            d="M834.70118,87.3276V32.667h43.8886V44.40281h-30.9472v9.4048h25.0791v11.3345h-25.0791v10.4497h30.9472V87.3276Z"
            transform="translate(0.00049)"></path>
          <path
            fill="var(--dhm-ci-logo-color)"
            d="M903.35448,71.09031a32.64077,32.64077,0,0,0,17.2822,5.4659c5.3858,0,8.7617-1.7686,8.7617-5.2247,0-2.4116-1.7685-3.8584-6.18938-4.9838L914.28608,63.936c-9.4052-2.49169-13.9062-7.47559-13.9062-15.19229,0-9.3243,7.1543-16.8003,21.8642-16.8003a47.03563,47.03563,0,0,1,19.6944,4.3408l-3.7783,11.6557a36.63188,36.63188,0,0,0-16.4786-4.4213c-5.30558,0-7.55658,1.6879-7.55658,4.3408,0,2.41159,1.60838,3.376,4.98438,4.3408l9.7265,2.8135c10.0479,2.8935,14.3877,7.7968,14.3877,15.353,0,10.53029-9.2431,17.76459-22.9091,17.76459-8.0381,0-16.4786-2.73289-20.0957-4.74259Z"
            transform="translate(0.00049)"></path>
        </g>
        <g id="Bildmarke">
          <g mask="url(#dhm-logo-mask)">
            <path
              fill="var(--dhm-ci-logo-color)"
              d="M248.34469,195.9121q7.90575-23.14155,7.9199-52.6934,0-36.9741-11.0498-64.17179-11.05515-27.1905-31.0234-44.6221Q194.21094,17.00336,166.5928,8.5,138.96295.00387,105.8198,0H48.1533Z"
              transform="translate(0.00049)"></path>
          </g>
          <g mask="url(#dhm-logo-mask-2)">
            <path
              fill="var(--dhm-ci-logo-color)"
              d="M2.8291,0H-.00049V283.46484H105.396q8.30055,0,16.272-.5625Z"
              transform="translate(0.00049)"></path>
          </g>
          <g mask="url(#dhm-logo-mask-3)">
            <path
              opacity="0.75"
              fill="var(--dhm-ci-logo-color)"
              d="M105.396,283.46484q32.72025,0,60.3481-8.71289,27.61965-8.70563,47.80959-26.34965a120.53441,120.53441,0,0,0,31.4492-43.7724q11.25585-26.1372,11.2617-61.4112,0-36.00285-10.4873-62.72649L63.1655,283.46484Z"
              transform="translate(0.00049)"></path>
          </g>
          <g mask="url(#dhm-logo-mask)">
            <path
              fill="var(--dhm-ci-logo-color)"
              d="M152.582,4.81641A216.75745,216.75745,0,0,0,105.8198,0H-.00049V283.46484H36.8711Z"
              transform="translate(0.00049)"></path>
          </g>
          <g mask="url(#dhm-logo-mask-5)">
            <path
              fill="var(--dhm-ci-logo-color)"
              d="M248.34469,195.9121q7.90575-23.14155,7.9199-52.6934,0-36.9741-11.0498-64.17179-11.05515-27.1905-31.0234-44.6221Q194.21094,17.00336,166.5928,8.5,138.96295.00387,105.8198,0H48.1533Z"
              transform="translate(0.00049)"></path>
          </g>
          <g mask="url(#dhm-logo-mask-3)">
            <path
              opacity="0.75"
              fill="var(--dhm-ci-logo-color)"
              d="M105.396,283.46484q32.72025,0,60.3481-8.71289,27.61965-8.70563,47.80959-26.34965a120.53441,120.53441,0,0,0,31.4492-43.7724q11.25585-26.1372,11.2617-61.4112,0-36.00285-10.4873-62.72649L63.1655,283.46484Z"
              transform="translate(0.00049)"></path>
          </g>
          <g mask="url(#dhm-logo-mask-7)">
            <path
              fill="var(--dhm-ci-logo-color)"
              d="M152.582,4.81641A216.75745,216.75745,0,0,0,105.8198,0H-.00049V283.46484H36.8711Z"
              transform="translate(0.00049)"></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default DHMLogo;
